// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AzureAksNodePoolTaintEffect } from './AzureAksNodePoolTaintEffect';
import {
  AzureAksNodePoolTaintEffectFromJSON,
  AzureAksNodePoolTaintEffectFromJSONTyped,
  AzureAksNodePoolTaintEffectToJSON,
  AzureAksNodePoolTaintEffectToJSONTyped,
} from './AzureAksNodePoolTaintEffect';

/**
 *
 * @export
 * @interface AzureAksNodePoolTaint
 */
export interface AzureAksNodePoolTaint {
  /**
   *
   * @type {AzureAksNodePoolTaintEffect}
   * @memberof AzureAksNodePoolTaint
   */
  effect?: AzureAksNodePoolTaintEffect;
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePoolTaint
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePoolTaint
   */
  value?: string;
}

/**
 * Check if a given object implements the AzureAksNodePoolTaint interface.
 */
export function instanceOfAzureAksNodePoolTaint(
  value: object,
): value is AzureAksNodePoolTaint {
  return true;
}

export function AzureAksNodePoolTaintFromJSON(
  json: any,
): AzureAksNodePoolTaint {
  return AzureAksNodePoolTaintFromJSONTyped(json, false);
}

export function AzureAksNodePoolTaintFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolTaint {
  if (json == null) {
    return json;
  }
  return {
    effect:
      json['effect'] == null
        ? undefined
        : AzureAksNodePoolTaintEffectFromJSON(json['effect']),
    key: json['key'] == null ? undefined : json['key'],
    value: json['value'] == null ? undefined : json['value'],
  };
}

export function AzureAksNodePoolTaintToJSON(json: any): AzureAksNodePoolTaint {
  return AzureAksNodePoolTaintToJSONTyped(json, false);
}

export function AzureAksNodePoolTaintToJSONTyped(
  value?: AzureAksNodePoolTaint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    effect: AzureAksNodePoolTaintEffectToJSON(value['effect']),
    key: value['key'],
    value: value['value'],
  };
}
